var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLineLoggedIn
    ? _c(
        "footer",
        {
          staticClass: "footer-section",
          class: [_vm.hidden, _vm.hiddenSM, _vm.hiddenXS],
          attrs: { "aria-hidden": "true" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "form-group d-block d-sm-none" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.footer.language")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-jumbo" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentLanguage,
                          expression: "currentLanguage"
                        }
                      ],
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.currentLanguage = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.$parent.setLocaleLanguage(
                              _vm.currentLanguage
                            )
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "en" } }, [
                        _vm._v("English")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "th" } }, [
                        _vm._v("ภาษาไทย")
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [_vm._v(" ")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-2 mb-4" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("message.footer.customer")))]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled footer-list" }, [
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/booking/start" } }, [
                      _vm._v(_vm._s(_vm.$t("message.menu.book_cleaner")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/promotions" } }, [
                      _vm._v(_vm._s(_vm.$t("message.menu.promotions")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/pricing" } }, [
                      _vm._v(_vm._s(_vm.$t("message.menu.pricing")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/service" } }, [
                      _vm._v(_vm._s(_vm.$t("message.footer.our_service")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/term" } }, [
                      _vm._v(_vm._s(_vm.$t("message.footer.terms_of_use")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/term-and-conditions" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.footer.terms_and_conditions"))
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/privacy" } }, [
                      _vm._v(_vm._s(_vm.$t("message.footer.privacy_policy")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/safety" } }, [
                      _vm._v(_vm._s(_vm.$t("message.footer.safety")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(0)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 mb-4" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("message.footer.professional")))]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled footer-list" }, [
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/apply" } }, [
                      _vm._v(_vm._s(_vm.$t("message.footer.be_a_professional")))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.footer.download_apps")))
                ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("message.footer.contact_us")))]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled footer-list" }, [
                _c("li", [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _vm._v(" \n          "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.footer.address.01"))
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "mt-4" }, [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _vm._v(" \n          "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.footer.address.02"))
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("h4", [_vm._v(" ")]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled footer-list" }, [
                _c("li", [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _vm._v(" \n          "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.footer.address.03"))
                    }
                  })
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "mt-4" }, [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _vm._v(" \n          "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.footer.address.04"))
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("h4", [_vm._v(" ")]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled footer-list" }, [
                _c("li", [
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                  _vm._v(" \n          "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.footer.address.06"))
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _vm._m(3)
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "mt-3 d-flex" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.facebook.com/beneatco",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: "/static/img/ic-facebook.svg",
                alt: "",
                width: "36"
              }
            })
          ]
        ),
        _vm._v("\n             \n            "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/beneat.co/?hl=th",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: "/static/img/ic-instagram.svg",
                alt: "",
                width: "36"
              }
            })
          ]
        ),
        _vm._v("\n             \n            "),
        _c(
          "a",
          { attrs: { href: "https://twitter.com/BeNeatCo", target: "_blank" } },
          [
            _c("img", {
              attrs: { src: "/static/img/ic-twitter.svg", alt: "", width: "36" }
            })
          ]
        ),
        _vm._v("\n             \n            "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.tiktok.com/@beneat.official",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: { src: "/static/img/ic-tiktok.png", alt: "", width: "37" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "list-unstyled footer-list mt-3" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-app-store.svg"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.beneat.app",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-play-store.svg"
              }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2" }, [
      _c("h4", [_vm._v(" ")]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled footer-list" }, [
        _c("li", [
          _c("i", { staticClass: "fas fa-phone" }),
          _vm._v("  "),
          _c(
            "a",
            { staticClass: "text-light", attrs: { href: "tel:+6621131138" } },
            [_vm._v("02-113-1138")]
          ),
          _vm._v(",\n          "),
          _c(
            "a",
            { staticClass: "text-light", attrs: { href: "tel:+66927572999" } },
            [_vm._v("092-757-2999")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", { staticClass: "fas fa-envelope" }),
          _vm._v("  "),
          _c(
            "a",
            {
              staticClass: "text-light",
              attrs: { href: "mailto:info@beneat.co" }
            },
            [_vm._v("info@beneat.co")]
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v(" ")]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://line.me/R/ti/p/%40hnk7011n",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: {
                  height: "38",
                  alt: "Line BeNeat",
                  src: "/static/img/btn-line.png"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.messenger.com/t/beneatco/",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: {
                  height: "38",
                  alt: "FB Messenger BeNeat",
                  src: "/static/img/btn-fb-messenger.png"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [_c("h4", [_vm._v("มาตรฐานที่ได้รับ")])]),
        _vm._v(" "),
        _c("li", [
          _c("img", {
            staticClass: "responsive-img-standard",
            attrs: {
              src: "/static/img/loco-issa-cleaning-management-institute.png",
              alt: "issa cleaning management institute"
            }
          })
        ]),
        _vm._v(" "),
        _c("li", [
          _c("img", {
            staticClass: "responsive-img-standard",
            attrs: { src: "/static/img/Logo-DTC-LCB.png", alt: "DTC LCB" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _vm._v(
          "\n      Copyright © 2025 by BeNeat Co.,Ltd. All right reserved.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1429
// module chunks = 0